import { render } from "./code-change.vue?vue&type=template&id=53a85e20&scoped=true&ts=true"
import script from "./code-change.vue?vue&type=script&lang=ts"
export * from "./code-change.vue?vue&type=script&lang=ts"

import "./code-change.vue?vue&type=style&index=0&id=53a85e20&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a85e20"]])

export default __exports__